import { debounce } from '@/core/lib/utils/debounce'
import { useTranslations } from 'next-intl'
import { ChangeEvent, useRef, useState } from 'react'

export function PriceFilter({
  min,
  max,
  onChange,
}: {
  min?: string
  max?: string
  onChange: ({ max, min }: { min: string; max: string }) => void
}) {
  const t = useTranslations()
  const [minVal, setMinVal] = useState(min)
  const [maxVal, setMaxVal] = useState(max)

  const minCancelRef = useRef<() => void>(null)
  const maxCancelRef = useRef<() => void>(null)

  const onMinChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (minCancelRef.current) {
      minCancelRef.current()
    }
    const value = e.target.value
    setMinVal(value)
    const debouncedSet = debounce((v: string) =>
      onChange({ min: v, max: max ?? '1000' }),
    )

    minCancelRef.current = debouncedSet.cancel

    debouncedSet(value)
  }

  const onMaxChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (maxCancelRef.current) {
      maxCancelRef.current()
    }
    const value = e.target.value
    setMaxVal(value)

    const debouncedSet = debounce((v: string) =>
      onChange({ max: v, min: min ?? '0' }),
    )

    maxCancelRef.current = debouncedSet.cancel

    debouncedSet(value)
  }

  return (
    <div>
      <h3 className='my-2 text-lg font-semibold'>{t('search.Price')}</h3>
      <div className='flex items-center gap-2'>
        <input
          type='number'
          value={minVal ?? ''}
          onChange={onMinChange}
          className='w-1/2 rounded-md border p-1 text-sm'
        />
        <span>—</span>
        <input
          type='number'
          value={maxVal ?? ''}
          onChange={onMaxChange}
          className='w-1/2 rounded-md border p-1 text-sm'
        />
      </div>
    </div>
  )
}
